<template>
  <div class="sidebar-app-info">
    <SidebarTopLeftOrientation>
      <div class="sidebar-top-left-orientation__left">
        <button
          @click="closeSidebarAppInfo"
          class="sidebar-top-left-orientation__button"
        >
          <svg class="sidebar-top-left-orientation__button__icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
          <div class="sidebar-top-left-orientation__button__text">
            Sluit
          </div>
        </button>
      </div>
    </SidebarTopLeftOrientation>
    <div class="sidebar-app-info__bottom">
      <template v-if="loadedApp">
        <div v-html="loadedApp.info"></div>
      </template>
    </div>
    <portal to="page-shadow">
      <PageShadow />
    </portal>
  </div>
</template>

<script>
import PageShadow from "@/components/PageShadow.vue";
import SidebarTopLeftOrientation from "@/components/SidebarTopLeftOrientation.vue";
import LoadOrReturnApp from "@/services/LoadOrReturnApp.js";

export default {
  components: {
    PageShadow,
    SidebarTopLeftOrientation
  },
  methods: {
    closeSidebarAppInfo() {
      this.$store.commit("closeSidebarAppInfo");
    }
  },
  data() {
    return {
      loadedApp: null
    };
  },
  mounted() {
    let self = this;

    LoadOrReturnApp().then(function(app) {
      self.loadedApp = app.data;
    });
  },
  computed: {
    sidebarAppInfo() {
      return this.$store.sidebarAppInfo;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sidebar-app-info {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: #fff;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;
  height: auto;

  &__bottom {
    flex: 1;
    padding: $spacing-3;
    overflow-y: auto;
    @extend %text-medium;

    &::v-deep a {
      color: $color-green-1;

      &:hover {
        text-decoration: underline;
      }
    }

    &::v-deep h3 {
      @extend %text-title-2;
      margin-top: $spacing-4;
    }
    &::v-deep p {
      @extend %text-medium;
    }
  }
}
@media (min-width: 768px) {
  .sidebar-app-info {
    &__bottom {
      padding: $spacing-4;
    }
  }
}
</style>
